const ConditionalWrapper = ({ condition, wrapper, children }) =>   condition ? wrapper(children) : children;

module.exports = ConditionalWrapper;


// WEBPACK FOOTER //
// ./src/common/ConditionalWrapper/ConditionalWrapper.js